import React from "react";
import PropTypes from "prop-types";

import { extractIdFromYoutubeUrl, formatNumber } from "../../../helpers/tools";
import { DEFAULT_VIDEO_ASPECT_RATIO } from "../../../helpers/constants";

import { YoutubeVideoIFrame, YoutubeVideoContainer } from "../../atoms/YoutubeVideoContainer";

const YoutubeVideo = (props) => {
  const { videoUrl, videoAspectRatio, isFromWineDetails } = props;

  // TODO [DEV-876] migrate youtube url to youtube id
  const videoId = extractIdFromYoutubeUrl(videoUrl);

  /**
   * Calculates the ratio percentage for padding bottom percentage,
   * according to the 'videoAspectRatio' API field.
   *
   * Ratio percent = (1 / videoAspectRatio) X 100.
   *
   * @return {Number}
   * */
  const getRatioPercent = () => {
    if (isFromWineDetails && videoAspectRatio === 1) {
      // When square video is opened in a new wine details page,
      // Then, youtube action buttons are hidden under the absolute "Add" and "Close Tasting Video" buttons.
      // Thus, by multiplying by 0.75, we decrease the ratio percentage...
      // ...to show the action buttons on top of the the absolute "Add" and "Close Tasting Video" buttons.
      return formatNumber(((0.75 * 1) / videoAspectRatio) * 100, 2, false);
    }
    return formatNumber((1 / videoAspectRatio) * 100, 2, false);
  };

  return (
    <YoutubeVideoContainer ratioPercent={getRatioPercent()}>
      <YoutubeVideoIFrame
        id="player"
        src={`https://www.youtube.com/embed/${videoId}?origin=${encodeURIComponent(window.location.origin)}`}
        frameBorder="0"
        allowFullScreen
      />
    </YoutubeVideoContainer>
  );
};

YoutubeVideo.propTypes = {
  videoUrl: PropTypes.string.isRequired,
  isFromWineDetails: PropTypes.bool,
  videoAspectRatio: PropTypes.number,
};

YoutubeVideo.defaultProps = {
  isFromWineDetails: false,
  videoAspectRatio: DEFAULT_VIDEO_ASPECT_RATIO,
};

export default YoutubeVideo;
